// Mineurs et données (D-103) : accès aux données. Les règles sont dans la base : un mineur ne voit et ne
// prend que les créneaux ouverts aux jeunes, seul le bureau les ouvre ; la page « Mentions légales et
// données » se lit sans compte (par l'adresse du club ou un lien reçu), ses champs se règlent au bureau.
import { supabase } from './supabase';
import type { ClubLegal, RepRole } from '../domain/legal';

const db = () => {
  if (!supabase) throw new Error('Base non configurée');
  return supabase;
};
async function must<T>(q: PromiseLike<{ data: T; error: { message: string; code?: string } | null }>): Promise<T> {
  const { data, error } = await q;
  if (error) throw Object.assign(new Error(error.message), { code: error.code });
  return data;
}

// --- Créneaux « Ouvert aux jeunes » -------------------------------------------------------
/** Le réglage « Ouvert aux jeunes » des créneaux du club à partir d'une date. */
export async function slotYouth(clubId: string, from: string): Promise<Map<string, boolean>> {
  const rows = await must(db().from('volunteer_slots').select('id, youth_open').eq('club_id', clubId).gte('occurrence_date', from)) as { id: string; youth_open: boolean }[] | null;
  return new Map((rows ?? []).map(r => [r.id, r.youth_open]));
}
/** Le bureau ouvre (ou ferme) un créneau aux jeunes ; null : la règle par défaut. */
export const setSlotYouth = (slotId: string, open: boolean | null) =>
  must(db().from('volunteer_slots').update({ youth_open: open }).eq('id', slotId));
/** Après l'enregistrement d'un appel : « Ouvert aux jeunes » de chacun de ses créneaux (dans l'ordre). */
export async function setCallYouth(callId: string, open: boolean[]): Promise<void> {
  const on = open.flatMap((v, i) => (v ? [i] : [])), off = open.flatMap((v, i) => (v ? [] : [i]));
  if (on.length) await must(db().from('volunteer_slots').update({ youth_open: true }).eq('call_id', callId).in('position', on));
  if (off.length) await must(db().from('volunteer_slots').update({ youth_open: false }).eq('call_id', callId).in('position', off));
}

// --- Mentions légales et données du club ------------------------------------------------------
/** La page du club : par son adresse, par un lien reçu (/i/, /s/, /partenaires/), ou (membre) par le club. */
export const clubLegal = async (q: { slug?: string | null; token?: string | null; club?: string | null }) =>
  (await must(db().rpc('club_legal', { p_slug: q.slug ?? null, p_token: q.token ?? null, p_club: q.club ?? null }))) as ClubLegal | null;

export interface LegalSettings { legal_name: string | null; legal_address: string | null; legal_rep: string | null; legal_rep_role: RepRole | null; data_email: string | null }
export const legalSettings = async (clubId: string) =>
  (await must(db().from('clubs').select('legal_name, legal_address, legal_rep, legal_rep_role, data_email').eq('id', clubId).single())) as LegalSettings;
export const saveLegalSettings = (clubId: string, s: LegalSettings) => must(db().from('clubs').update(s).eq('id', clubId));
